import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Item({ to, label }) {
  const { pathname } = useLocation();
  const active = pathname === to;

  return (
    <Link
      to={to}
      className={`flex items-center justify-between rounded-2xl px-4 py-3 text-sm font-semibold transition ${
        active ? 'bg-slate-100 text-navy' : 'text-slate-700 hover:bg-slate-100 hover:text-navy'
      }`}
    >
      <span>{label}</span>
      <span className="text-slate-400">›</span>
    </Link>
  );
}

function WorkerSidebar({ links }) {
  const sideLinks = links || [
    { to: '/worker', label: 'Home' },
    { to: '/worker/applications', label: 'Applications' },
    { to: '/worker/hired', label: 'Hired Jobs' },
    { to: '/worker/completed', label: 'Completed Jobs' },
    { to: '/worker/saved', label: 'Saved Jobs' },
    { to: '/worker/messages', label: 'Messages' },
  ];

  return (
    <div className="rounded-3xl bg-white p-4 shadow-sm space-y-2">
      {sideLinks.map((item) => <Item key={item.to} to={item.to} label={item.label} />)}
    </div>
  );
}

export default WorkerSidebar;

